export const STATUS_SHOP_ORDERS = {
	CREATED: 1,
	IN_REALIZATION: 2,
	REALIZED: 3,
	CANCELED: 4,
};

export const TAB_SHOP_ORDERS = {
	ALL: 'all',
	CREATED: 'created',
	IN_REALIZATION: 'in-realization',
	CANCELED: 'canceled',
	REALIZED: 'realized',
};
